<div class="cmx-mobile-app-selector">
  <div
    class="cmx-mobile-app-selector__close"
    [ngClass]="{ 'cmx-mobile-app-selector__close--rtl': (layout.direction | async) === 'rtl' }"
  >
    <span (click)="onClose()" class="cmx-icon-close"></span>
  </div>
  <div class="cmx-mobile-app-selector__label">
    {{ layout.appMenuLabel | async }}
  </div>
  <div class="cmx-mobile-app-selector__items">
    <div
      *ngFor="let item of layout.appMenuItems | async"
      class="cmx-mobile-app-selector__item"
      (click)="onItemClick(item.id)"
    >
      <div class="cmx-icon cmx-mobile-app-selector__item-icon-container">
        <span class="cmx-mobile-app-selector__item-icon" [ngClass]="item.icon"></span>
      </div>
      <div class="cmx-mobile-app-selector__item-label">{{ item.name }}</div>
    </div>
  </div>
</div>
